import React from 'react';
import './SuccessCard.css';
import { SuccessIcon } from '../icons/successIcon';

const SuccessCard = ({ title, description }) => {
  return (
    <div className='success-card'>
      <div className='success-title'>{title}</div>
      <p className='success-text'>{description}</p>
    </div>
  );
};

export default SuccessCard;
